import { targetType } from '@/constants/operationSetting/option';
export default {
    isOpen: false,
    selectedTarget: targetType.HUB,
    hub: {
        list: [],
        checkedList: [],
        searchQuery: '',
        selectedHub: null,
    },
    store: {
        list: [],
        checkedList: [],
        searchQuery: '',
    },
};
